import { Injectable } from '@angular/core';
import {
  PackagingLevelDetailScenario,
  ProjectImportInfo,
  ProjectScope,
} from '@piqet-angular/shared';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'apps/piqet-angular/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ImportDataService {
  apiUrl = environment.url;

  constructor(private http: HttpClient) {}

  public projectInfoSubject = new BehaviorSubject<ProjectImportInfo>(new ProjectImportInfo());
  public projectInfo$ = this.projectInfoSubject.asObservable();

  private countryListSubject = new BehaviorSubject<any[]>([]);
  private selectedCountrySubject = new BehaviorSubject<any>(null);

  countryList$ = this.countryListSubject.asObservable();
  selectedCountry$ = this.selectedCountrySubject.asObservable();

  private PackagingLevelDetailInfoSubject = new BehaviorSubject<PackagingLevelDetailScenario[]>([]);

  public PackagingLevelDetailInfo$ = this.PackagingLevelDetailInfoSubject.asObservable();

  private projectScopeSubject = new BehaviorSubject<any>(ProjectScope.SimpleRetailPackage);

  projectScope$ = this.projectScopeSubject.asObservable();

  private projectProductLossSubject = new BehaviorSubject<any>(null);

  projectProductLossScope$ = this.projectProductLossSubject.asObservable();

  private isSwitchOnCostSubject = new BehaviorSubject<any>(false);

  isSwitchOnCost$ = this.isSwitchOnCostSubject.asObservable();

  private importedFileSubject = new BehaviorSubject<{
    name: string;
    data: string;
    type: string;
  } | null>(null);
  importedFile$ = this.importedFileSubject.asObservable();

  private materialUpdatedSubject = new Subject<void>();
  materialUpdated$ = this.materialUpdatedSubject.asObservable();

  //Import data

  get projectInfo(): ProjectImportInfo {
    return this.projectInfoSubject.value;
  }

  getProjectInfo(): ProjectImportInfo {
    return this.projectInfoSubject.getValue();
  }
  updateProjectImportInfo(updatedProjectInfo: ProjectImportInfo): void {
    this.projectInfoSubject.next(updatedProjectInfo);
  }
  addImportProjectData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ImportProject/AddImportFile`, payload);
  }
  getMasterDataForImportProject() {
    return this.http.get<any>(`${this.apiUrl}/ImportProject/GetMasterDataForImportProject`);
  }
  getImportedProjectLogByOrganization(status: number) {
    return this.http.get<any>(
      `${this.apiUrl}/ImportProject/GetImportedProjectLogByOrganization?status=${status}`
    );
  }
  getActionRequiredDataById(id: number) {
    return this.http.get<any>(`${this.apiUrl}/ImportProject/GetActionRequiredDataById?id=${id}`);
  }
  // Import data end

  //Default country
  setCountryList(countries: any[]): void {
    this.countryListSubject.next(countries);
  }

  getCountryList(): any[] {
    return this.countryListSubject.getValue();
  }

  setCountry(id: any, name: any): void {
    const selectedCountry = { id, name };
    this.selectedCountrySubject.next(selectedCountry);
  }

  getSelectedCountry(): any {
    return this.selectedCountrySubject.getValue();
  }
  //Default country end

  //Packaging Levels
  get PackagingLevelDetailInfo(): PackagingLevelDetailScenario[] {
    return this.PackagingLevelDetailInfoSubject.value;
  }

  getPackagingLevelDetailInfo(): PackagingLevelDetailScenario[] {
    return this.PackagingLevelDetailInfoSubject.getValue();
  }
  updatePackagingLevelDetailInfo(updatedProjectInfo: PackagingLevelDetailScenario[]): void {
    this.PackagingLevelDetailInfoSubject.next(updatedProjectInfo);
  }
  //Packaging Levels end

  //Project scope

  updateProjectScope(scope: any) {
    this.projectScopeSubject.next(scope);
  }

  getCurrentScope(): any {
    return this.projectScopeSubject.value;
  }

  updateProjectProductLoss(scope: any) {
    this.projectProductLossSubject.next(scope);
  }

  getCurrentProductLossScope(): any {
    return this.projectProductLossSubject.value;
  }

  //Project scope end

  // Switch on cost
  getSwitchOnCost() {
    return this.isSwitchOnCostSubject.value;
  }

  updateSwitchOnCost(value: any) {
    this.isSwitchOnCostSubject.next(value);
  }
  // End Switch on cost
  updateActionRequiredDataList(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ImportProject/UpdateActionRequiredDataList`,
      payload
    );
  }

  getTemplatesByOrganization() {
    return this.http.get<any>(`${this.apiUrl}/ImportProject/GetAllTemplatesByOrganization`);
  }

  addOrUpdateExcelImportTemplate(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ImportProject/AddOrUpdateExcelImportTemplate`,
      payload
    );
  }

  getExcelImportTemplateById(id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ImportProject/GetExcelImportTemplateById?templateId=${id}`
    );
  }

  createProjectLogTemp(formData: FormData, templateId: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ImportProject/CreateProjectLogTemp?templateId=${templateId}`,
      formData
    );
  }

  setImportedFile(file: { name: string; data: string; type: string }) {
    this.importedFileSubject.next(file);
  }

  getImportedFile(): { name: string; data: string; type: string } | null {
    return this.importedFileSubject.value;
  }

  clearImportedFile() {
    this.importedFileSubject.next(null);
  }

  triggerMaterialUpdate() {
    this.materialUpdatedSubject.next();
  }
}
